<template>
    <Head title="Applicant Training"></Head>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <Toast />
                <DataTable
                    ref="dt"
                    :value="models"
                    :lazy="true"
                    dataKey="id"
                    v-model:selection="selectedModels"
                    :paginator="true"
                    :rows="10"
                    :loading="loading"
                    :total-records="totalRecords"
                    v-model:filters="filters"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25]"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} models"
                    responsiveLayout="scroll"
                    @row-select="onRowSelect"
                    @row-unselect="onRowUnselect"
                    @page="onPage($event)"
                    @sort="onSort($event)"
                >
                    <template #header>
                        <div
                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
                        >
                            <h5 class="m-0">Manage Pengajuan Cuti</h5>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText
                                    @change="onFilter($event)"
                                    v-model="filters['global'].value"
                                    placeholder="Search..."
                                />
                            </span>
                        </div>
                    </template>

                    <Column
                        selectionMode="multiple"
                    ></Column>
                    <Column
                        field="user.name"
                        header="Nama Karyawan"
                        :sortable="true"
                        headerStyle="width:50%;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Nama Karyawan</span>
                            {{ slotProps.data.user.name }}
                        </template>
                    </Column>
                    <Column
                        field="master_cuti.name"
                        header="Kriteria Cuti"
                        :sortable="true"
                        headerStyle="width:50%;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Kriteria Cuti</span>
                            {{ slotProps.data.master_cuti.name }}
                        </template>
                    </Column>
                    <Column
                        field="tanggal"
                        header="Tanggal"
                        :sortable="true"
                        headerStyle="width:50%;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Tanggal</span>
                            {{ slotProps.data.tanggal.value }}
                        </template>
                    </Column>
                    <Column
                        field="alasan_cuti"
                        header="Alasan Cuti"
                        :sortable="true"
                        headerStyle="width:50%;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Alasan Cuti</span>
                            {{ slotProps.data.alasan_cuti }}
                        </template>
                    </Column>
                    <Column
                        field="status_cuti"
                        header="status"
                        :sortable="true"
                        headerStyle="width:50%;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Status</span>
                            <Badge :value="slotProps.data.status" class="text-white" :severity="badgeColor[slotProps.data.status]"></Badge>
                        </template>
                    </Column>
                    <Column headerStyle="width:50%;">
                        <template #body="slotProps">
                            <div v-if="slotProps.data.status === 'waiting'" class="flex align-items-center">
                                <Button
                                    icon="pi pi-check"
                                    class="p-button-rounded p-button-success mr-2"
                                    @click="successVacation(slotProps.data)"
                                />
                                <Button
                                    icon="pi pi-times"
                                    class="p-button-rounded p-button-danger"
                                    @click="failedVacation(slotProps.data)"
                                />
                            </div>
                            <div v-else class="flex align-items-center">
                                <Button
                                    icon="pi pi-eye"
                                    class="p-button-rounded p-button-primary mr-2"
                                    @click="detailVacation(slotProps.data)"
                                />
                            </div>
                        </template>
                    </Column>
                </DataTable>

                <Dialog
                    v-model:visible="successModalDialog"
                    :style="{ width: '450px' }"
                    header="Pengajuan Cuti Disetujui"
                    :modal="true"
                    class="p-fluid"
                >
                    <div class="field">
                        <label for="name">Pilih Cuti</label>
                        <Dropdown v-model="model.mst_cuti_ids" :options="masterVacations" optionLabel="name" placeholder="Pilih Cuti" disabled />
                        <small class="p-invalid" v-if="submitted && !model.mst_cuti_ids"
                            >Master Cuti is required.</small
                        >
                    </div>
                    <div class="field">
                        <label for="tanggal">Tanggal</label>
                        <Calendar id="tanggal" v-model="model.tanggal" disabled :inline="true" />
                        <small
                            class="p-invalid"
                            v-if="submitted && !model.tanggal"
                            >Tanggal Mulai is required.</small
                        >
                    </div>
                    <div class="field">
                        <label for="name">Alasan Cuti</label>
                        <Textarea
                            id="name"
                            v-model.trim="model.alasan_cuti"
                            required="true"
                            autofocus
                            disabled
                            :class="{ 'p-invalid': submitted && !model.alasan_cuti }"
                        />
                        <small class="p-invalid" v-if="submitted && !model.alasan_cuti"
                            >Alasan Cuti is required.</small
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="Cancel"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="hideDialog"
                        />
                        <Button
                            label="Disetujui"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="saveSuccessVacation"
                        />
                    </template>
                </Dialog>

                <Dialog
                    v-model:visible="failedModalDialog"
                    :style="{ width: '450px' }"
                    header="Pengajuan Cuti Tidak Disetujui"
                    :modal="true"
                    class="p-fluid"
                >
                    <div class="field">
                        <label for="name">Pilih Cuti</label>
                        <Dropdown v-model="model.mst_cuti_ids" :options="masterVacations" optionLabel="name" placeholder="Pilih Cuti" disabled />
                        <small class="p-invalid" v-if="submitted && !model.mst_cuti_ids"
                            >Master Cuti is required.</small
                        >
                    </div>
                    <div class="field">
                        <label for="tanggal">Tanggal</label>
                        <Calendar id="tanggal" v-model="model.tanggal" disabled :inline="true" />
                        <small
                            class="p-invalid"
                            v-if="submitted && !model.tanggal"
                            >Tanggal Mulai is required.</small
                        >
                    </div>
                    <div class="field">
                        <label for="name">Alasan Cuti</label>
                        <Textarea
                            id="name"
                            v-model.trim="model.alasan_cuti"
                            required="true"
                            autofocus
                            disabled
                            :class="{ 'p-invalid': submitted && !model.alasan_cuti }"
                        />
                        <small class="p-invalid" v-if="submitted && !model.alasan_cuti"
                            >Alasan Cuti is required.</small
                        >
                    </div>
                    <div class="field">
                        <label for="name">Catatan</label>
                        <Textarea
                            id="name"
                            v-model.trim="model.catatan"
                            required="true"
                            autofocus
                            :class="{ 'p-invalid': submitted && !model.catatan }"
                        />
                        <small class="p-invalid" v-if="submitted && !model.catatan"
                            >Catatan is required.</small
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="Cancel"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="hideDialog"
                        />
                        <Button
                            label="Disetujui"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="saveFailedVacation"
                        />
                    </template>
                </Dialog>

                <Dialog
                    v-model:visible="detailModalDialog"
                    :style="{ width: '450px' }"
                    header="Pengajuan Cuti Tidak Disetujui"
                    :modal="true"
                    class="p-fluid"
                >
                    <div class="field">
                        <label for="name">Pilih Cuti</label>
                        <Dropdown v-model="model.mst_cuti_ids" :options="masterVacations" optionLabel="name" placeholder="Pilih Cuti" disabled />
                        <small class="p-invalid" v-if="submitted && !model.mst_cuti_ids"
                            >Master Cuti is required.</small
                        >
                    </div>
                    <div class="field">
                        <label for="tanggal">Tanggal</label>
                        <Calendar id="tanggal" v-model="model.tanggal" disabled :inline="true" />
                        <small
                            class="p-invalid"
                            v-if="submitted && !model.tanggal"
                            >Tanggal Mulai is required.</small
                        >
                    </div>
                    <div class="field">
                        <label for="name">Alasan Cuti</label>
                        <Textarea
                            id="name"
                            v-model.trim="model.alasan_cuti"
                            required="true"
                            autofocus
                            disabled
                            :class="{ 'p-invalid': submitted && !model.alasan_cuti }"
                        />
                        <small class="p-invalid" v-if="submitted && !model.alasan_cuti"
                            >Alasan Cuti is required.</small
                        >
                    </div>
                    <div class="field">
                        <label for="name">Catatan</label>
                        <Textarea
                            id="name"
                            v-model.trim="model.catatan"
                            required="true"
                            autofocus
                            disabled
                            :class="{ 'p-invalid': submitted && !model.catatan }"
                        />
                        <small class="p-invalid" v-if="submitted && !model.catatan"
                            >Catatan is required.</small
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="Cancel"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="hideDialog"
                        />
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import { FilterMatchMode } from "primevue/api";
import { Head } from "@inertiajs/inertia-vue3";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Toolbar from "primevue/toolbar";
import Toast from "primevue/toast";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Dropdown from "primevue/dropdown";
import Calendar from "primevue/calendar";
import Textarea from "primevue/textarea";
import Badge from "primevue/badge";
import Dialog from "primevue/dialog";
import DatatableService from "../../Services/DatatableService";
import { Inertia } from "@inertiajs/inertia";
import axios from "axios";

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        Head,
        Button,
        InputText,
        Toolbar,
        Toast,
        DataTable,
        Column,
        Dropdown,
        Dialog,
        Badge,
        Calendar,
        Textarea
    },
    data() {
        return {
            // Data with type data object
            filters: {},
            lazyParams: {},
            model: {},
            badgeColor: {
                'waiting': 'warning',
                'success': 'success',
                'failed': 'danger'
            },
            status: {
                'holiday': 'pi pi-star text-yellow-600',
                'present': 'pi pi-check text-green-600',
                'absent': 'pi pi-times text-red-600',
                'unshift': 'pi pi-ban text-red-800',
            },
            userDetail: JSON.parse(sessionStorage.getItem('auth:me')) ?? [],
            // Data with type data string
            searchFilter: "",
            // data with type data boolean
            loading: true,
            submitted: false,
            selectAll: false,
            isExporting: false,
            successModalDialog: false,
            failedModalDialog: false,
            detailModalDialog: false,
            // data with type data numeric
            totalRecords: 0,
            date: 0,
            // data with type data any
            selectedModel: null,
            models: null,
            selectedModels: null,
        };
    },
    datatableService: null,
    created() {
        this.datatableService = new DatatableService();
        this.initFilters();
        let date = new Date();
        this.currentDate(date.getFullYear(), date.getMonth())
    },
    mounted() {
        this.loading = true;
        this.lazyParams = {
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: "id",
            sortOrder: -1,
            filters: this.filters,
        };
        this.loadLazyData();
        this.loadMasterVacation();
    },
    methods: {
        // Get API
        loadLazyData() {
            this.loading = true;

            this.loading = true;
            this.datatableService
                .getData(this.route("api.vacations.index"), this.lazyParams)
                .then((data) => {
                    this.models = data.data;
                    this.totalRecords = data.total;
                    this.loading = false;
                });
        },
        loadMasterVacation() {
            axios.get(this.route('api.master-vacations.data'))
            .then((data) => {
                this.masterVacations = data.data.data.data
            })
            .catch(err => {
                console.log(err)
            })
        },
        // Page Action
        onRowSelect() {
            this.selectAll = this.selectedModels.length === this.totalRecord;
        },
        onRowUnselect() {
            this.selectAll = false;
        },
        onPage(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        onSort(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        onFilter(event) {
            console.log(event)
            this.loadLazyData();
        },
        hideDialog() {
            this.successModalDialog = false;
            this.failedModalDialog = false;
            this.detailModalDialog = false;
            this.model = {};
        },
        successVacation(model) {
            this.model = {
                ...model,
                tanggal: new Date(model.tanggal.as),
                mst_cuti_ids: model.master_cuti
            }
            this.successModalDialog = true;
        },
        failedVacation(model) {
            this.model = {
                ...model,
                tanggal: new Date(model.tanggal.as),
                mst_cuti_ids: model.master_cuti
            }
            this.failedModalDialog = true;
        },
        detailVacation(model) {
            this.model = {
                ...model,
                tanggal: new Date(model.tanggal.as),
                mst_cuti_ids: model.master_cuti
            }
            this.detailModalDialog = true;
        },

        // Action methods
        saveSuccessVacation () {
            axios
                .post(this.route('api.vacation-apply.success', this.model.id))
                .then(() => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Vacation applied",
                        life: 3000,
                    });
                    this.loadLazyData();
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Vacation applied to be failed",
                        life: 3000,
                    });
                })
            this.hideDialog()
        },
        saveFailedVacation () {
            const data = {
                catatan: this.model.catatan
            }

            axios
                .post(this.route('api.vacation-apply.failed', this.model.id), data)
                .then(() => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Vacation not applied",
                        life: 3000,
                    });
                    this.loadLazyData();
                }).catch(() => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Vacation not applied to be failed",
                        life: 3000,
                    });
                })

            this.hideDialog();
        },

        // Initiation Filter
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS, field: 'user.name' },
            };
        },
        // Current Date
        currentDate(year, month) {
            this.date = new Date(year, month, 0).getDate();
        }
    },
};
</script>
<style scoped lang="scss">
@import "../../../assets/demo/badges.scss";
</style>
